import api from '../utils/api';
import config from '../config';

const systemLogService = {
  // Get init data (types and actions)
  getInit: async () => {
    return api.get(config.endpoints.systemLogs.init);
  },

  // Get system logs list with pagination, sorting, and filtering
  getSystemLogs: async (params = {}) => {
    return api.get(config.endpoints.systemLogs.list, params);
  },
};

export default systemLogService;
